import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {StripeAccountsDetailedViewComponent} from './stripe-accounts-detailed-view/stripe-accounts-detailed-view.component';
import {StripeAccountsComponent} from './stripe-accounts.component';
import {StripeAccountsService} from '../../services/stripe-accounts.service';
import {StripeTransactionsListComponent} from './stripe-transactions-list/stripe-transactions-list.component';
import {StripePayoutsListComponent} from './stripe-payouts-list/stripe-payouts-list.component';
import {StripeAccountsFilterComponent} from '../../components/stripe-accounts-filter/stripe-accounts-filter.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        UtilsModule
    ],
    declarations: [
        StripeAccountsComponent,
        StripeAccountsDetailedViewComponent,
        StripeTransactionsListComponent,
        StripePayoutsListComponent,
        StripeAccountsFilterComponent
    ],
    providers: [
        StripeAccountsService
    ]
})

export class StripeAccountsModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-accounts.module.ts